class Components{

    static components = [];

    static addComponent(component)
    {
        Components.components.push(component);
    }


    static initComponents()
    {
        Components.components.forEach(component => {


            if(document.querySelector(component.component_selector) !== null)
            {

                document
                    .querySelectorAll(component.component_selector)
                    .forEach(
                        element => new component.component_class(element, component.component_selector, component.component_options)
                    )
            }

        });
    }

    static afterDocumentChangedEvent()
    {
        Components.components.forEach(component => {


            component.afterDocumentChangedEvent();

        });
    }

}

